import React from 'react';
import { ShieldCheck, SearchCheck, UserCheck, ShieldAlert, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

interface TrustFeaturesProps {
  onFeatureClick?: (id: string) => void;
}

export const TrustFeatures: React.FC<TrustFeaturesProps> = ({ onFeatureClick }) => {
  const { language } = useLanguage();
  const isFr = language === 'fr';

  const features = [
    {
      id: 'verify',
      title: isFr ? 'Vérifier un Titre' : 'Verify Title (Titre Foncier)',
      description: isFr
        ? 'Contrôle des numéros cadastraux et du propriétaire avant tout engagement.'
        : 'Cross-check cadastral records and boundary plans before making commitments.',
      icon: ShieldCheck,
    },
    {
      id: 'scam',
      title: isFr ? 'Signaler une Suspicion' : 'Report Suspicious Listings',
      description: isFr
        ? 'Alertez la communauté sur les litiges fonciers et les ventes litigieuses.'
        : 'Flag duplicate sales, disputed family plots, or fraudulent postings.',
      icon: SearchCheck,
    },
    {
      id: 'professionals',
      title: isFr ? 'Experts Immobiliers' : 'Accredited Specialists',
      description: isFr
        ? 'Notaires assermentés, géomètres OGEC et avocats du barreau.'
        : 'Reach sworn notaries, licensed surveyors, and property attorneys directly.',
      icon: UserCheck,
    },
    {
      id: 'legal',
      title: isFr ? 'Sécurité Juridique' : 'Protected Contracts',
      description: isFr
        ? 'Actes authentiques passés par-devant notaire assermenté selon la loi camerounaise.'
        : 'Authentic deeds executed directly before licensed notaries under Cameroonian law.',
      icon: ShieldAlert,
    },
    {
      id: 'coverage',
      title: isFr ? 'Dans les 10 Régions' : 'Across All 10 Regions',
      description: isFr
        ? 'Terrains, villas et locations de Douala et Yaoundé à Kribi et Garoua.'
        : 'From urban centers like Douala and Yaoundé to coastal Kribi and Buea.',
      icon: MapPin,
    },
  ];

  return (
    <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {features.map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.id}
              onClick={() => onFeatureClick?.(item.id)}
              className="bg-white border border-slate-200/90 rounded-xl p-4 flex items-start gap-3 hover:border-emerald-300 hover:shadow-2xs transition-all cursor-pointer group min-h-[88px]"
            >
              <div className="w-10 h-10 rounded-full bg-emerald-50 border border-emerald-100 group-hover:bg-emerald-100/70 flex items-center justify-center shrink-0 text-[#094426] transition-colors">
                <Icon className="w-5 h-5 stroke-[1.75]" />
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-900 group-hover:text-[#094426] leading-snug transition-colors">
                  {item.title}
                </p>
                <p className="text-xs sm:text-[13px] text-slate-600 leading-relaxed mt-1">
                  {item.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
